/**
 *
 * getStudentStates
 *
 */

import { uniqueId } from 'lodash-es';
import { idValues } from 'utils/arrays.js';

function getStudentStates(meetingSet) {
  const { students } = meetingSet;
  const meetingList = idValues(meetingSet.meetings);

  /**
   * Create initial list of meetings, i.e. set with all parents
   * @param {*} student
   */
  function makeMeetings(student) {
    const parentIds = student.connections.list;
    if (parentIds.length === 0) {
      return [];
    }
    return [{ id: uniqueId('tmp_'), studentId: student.id, parentIds }];
  }

  function getStudentState(studentId) {
    const student = meetingSet.students[studentId];
    const meetings = meetingList.filter((meeting) => meeting.studentId === studentId);
    const numParents = student.connections && student.connections.list.length;
    const base = { student, numParents };
    if (meetings.length > 0) {
      const booked = meetings.some((mt) => mt.details.assigned);
      return { ...base, checked: true, meetings, canChange: numParents > 0 && !booked };
    }
    const checked = !meetingSet.meetings; // checked if no meetings planned, unchecked if planned but none for this student
    return { ...base, checked, meetings: makeMeetings(student), canChange: numParents > 0 };
  }

  const result = {};
  students.list.forEach((studentId) => {
    result[studentId] = getStudentState(studentId);
  });
  return result;
}

export default getStudentStates;
